// firebase/network.js — État réseau léger, sans dépendance Firestore
// Partagé par OfflineIndicator (bundle initial) et firebase/config (bundle async)
let _isOnline = typeof navigator !== 'undefined' && 'onLine' in navigator ? navigator.onLine : true;
const _listeners = new Set();

export function onNetworkStateChange(cb) {
  _listeners.add(cb);
  return () => _listeners.delete(cb);
}
export const isOnline = () => _isOnline;
export const isOffline = () => !_isOnline;

export function _notifyNetworkState(online) {
  _isOnline = online;
  _listeners.forEach((cb) => { try { cb(online); } catch (_) {} });
}

if (typeof window !== 'undefined') {
  window.addEventListener('online',  () => _notifyNetworkState(true));
  window.addEventListener('offline', () => _notifyNetworkState(false));
}
